/** DEF-127 — 마이크 시작 실패를 실제 원인별 안내로 분류한다(순수 함수). */

export function classifyMicError(err: unknown): string {
  const g = globalThis as { isSecureContext?: boolean; navigator?: Navigator }
  const secure = g.isSecureContext !== false
  const hasMedia = !!g.navigator?.mediaDevices
  if (!secure || !hasMedia) {
    return '마이크를 열 수 없습니다. HTTPS(보안 컨텍스트)로 접속했는지 확인해 주세요. (오류: insecure-context)'
  }
  const e = err as { name?: string; micStage?: string } | null
  const name = e && typeof e === 'object' && typeof e.name === 'string' ? e.name : ''
  const tail = (label: string) => ` (오류: ${label})`
  switch (name) {
    case 'NotAllowedError':
    case 'SecurityError':
      return (
        '마이크 권한이 거부되었습니다. 브라우저 주소창의 권한 설정과 Windows 설정 > 개인정보 > 마이크의 "앱이 마이크에 접근" 허용을 확인해 주세요.' +
        tail(name)
      )
    case 'NotFoundError':
    case 'OverconstrainedError':
      return (
        '입력 장치를 찾을 수 없습니다. 마이크 또는 VB-Audio CABLE Output 이 Windows 녹음 장치에 있는지, 브라우저 사이트 설정에서 마이크 선택이 맞는지 확인해 주세요.' +
        tail(name)
      )
    case 'NotReadableError':
    case 'AbortError':
      return (
        '마이크 장치를 열 수 없습니다. 다른 앱이 독점 사용 중이거나 드라이버 문제일 수 있습니다. 화상회의 앱의 "독점 모드"와 다른 탭을 확인하고 장치를 다시 연결해 주세요.' +
        tail(name)
      )
    default:
      return (
        '마이크 장치는 열렸지만 오디오 처리 시작에 실패했습니다. 페이지를 새로고침한 뒤 다시 시도해 주세요.' +
        tail(e?.micStage || name || 'unknown')
      )
  }
}
